// @ts-nocheck
import React from "react"
import { BASE, JARGON, PATH } from '../modules/constants'
//#region icons
import CompaniesRoundedIcon from "../assets/images/companies-rounded.png"
import AppointmentsRoundedIcon from "../assets/images/appointments-rounded.png"
import LseNewsIcon from "../assets/images/lse-news.png"

import SearchRoundedIcon from "@mui/icons-material/SearchRounded"
import GroupRoundedIcon from "@mui/icons-material/GroupOutlined"
import AnnouncementOutlinedIcon from "@mui/icons-material/AnnouncementOutlined"
import StarIcon from "@mui/icons-material/Star"
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded'
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded"
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded"
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined'
//#endregion icons

export const TAB_DEFINITIONS = [
  {
    key: BASE.SEARCH,
    path: PATH[BASE.SEARCH],
    icon: <SearchRoundedIcon style={{ fontSize: 30, marginBottom: 0 }} />,
    label: portrait => portrait ? 'Co House' : 'Companies House',
    tooltipTitle: "search Companies House for a UK company or officer",
  },
  {
    key: BASE.DASHBOARD,
    path: PATH[BASE.DASHBOARD],
    icon: <DashboardRoundedIcon style={{ fontSize: 30, marginBottom: 0 }} />,
    label: () => "LSE Dashboard",
    tooltipTitle: "LSE Dashboard",
    leftLine: true,
  },
  {
    key: BASE.LSE.COMPANIES,
    path: PATH[BASE.LSE.COMPANIES],
    image: CompaniesRoundedIcon,
    label: portrait => portrait ? `${JARGON.LSE} Cos` : `${JARGON.LSE} ${JARGON.COMPANIES}`,
    tooltipTitle: `${JARGON.COMPANIES.toLowerCase()} listed on the London Stock Exchange`,
    leftLine: false,
  },
  {
    key: BASE.LSE.ROLES,
    path: PATH[BASE.LSE.ROLES],
    image: AppointmentsRoundedIcon,
    label: () => `${JARGON.LSE} ${JARGON.APPTS}`,
    tooltipTitle: `${JARGON.DIRECTOR.toLowerCase()} ${JARGON.APPTS.toLowerCase()} of ${JARGON.COMPANIES.toLowerCase()} listed on the London Stock Exchange`,
    leftLine: false,
  },
  {
    key: BASE.LSE.PEOPLE,
    path: PATH[BASE.LSE.PEOPLE],
    icon: <GroupRoundedIcon style={{ fontSize: 30, marginTop: 0, marginBottom: 0 }} />,
    label: portrait => portrait ? `${JARGON.LSE} ${JARGON.PEOPLE}` : `${JARGON.LSE} ${JARGON.PEOPLE}`,
    tooltipTitle: `${JARGON.PEOPLE.toLowerCase()} who are ${JARGON.DIRECTORS.toLowerCase()} of ${JARGON.COMPANIES.toLowerCase()} listed on the London Stock Exchange`,
    leftLine: false,
  },

  {
    key: BASE.LSE.NEWS,
    path: PATH[BASE.LSE.NEWS],
    image: LseNewsIcon,
    label: portrait => portrait ? `${JARGON.LSE} ${"News"}` : `${JARGON.LSE} ${"News"}`,
    tooltipTitle: `news`,
    leftLine: false,
  },
  {
    key: BASE.LSE.ADVISERS,
    path: PATH[BASE.LSE.ADVISERS],
    icon: < BusinessCenterOutlinedIcon style={{ fontSize: 30, marginTop: 0, marginBottom: 0 }} />,
    label: portrait => portrait ? `${JARGON.LSE} ${JARGON.ADVISERS}` : `${JARGON.LSE} ${JARGON.ADVISERS}`,
    tooltipTitle: `advisers`,
    feature: 'ShowAdvisers',
    leftLine: false,
  },
  {
    key: BASE.COMPANY,
    path: PATH[BASE.COMPANY],
    icon: <BusinessRoundedIcon style={{ fontSize: 24, marginTop: 3, marginBottom: 3 }} />,
    label: portrait => portrait ? JARGON.COMPANY : JARGON.COMPANY,
    tooltipTitle: "view the last selected company",
    leftLine: true,
  },
  {
    key: BASE.PERSON,
    path: PATH[BASE.PERSON],
    icon: <PersonOutlineRoundedIcon style={{ fontSize: 28, marginBottom: 2 }} />,
    label: () => JARGON.PERSON,
    tooltipTitle: "view the last selected person",
    leftLine: false,
  },
  {
    key: BASE.NEWS_RELEASE,
    path: PATH[BASE.NEWS_RELEASE],
    icon: <AnnouncementOutlinedIcon style={{ fontSize: 28, marginBottom: 2 }} />,
    label: () => "News",
    tooltipTitle: "view the last news release",
    leftLine: false,
  },
  {
    key: BASE.FAVOURITES,
    path: PATH[BASE.FAVOURITES],
    icon: <StarIcon style={{ fontSize: 28, marginBottom: 2 }} />,
    label: () => JARGON.FAVOURITES,
    tooltipTitle: "access favourites",
    leftLine: true,
  }
]

export const TAB = TAB_DEFINITIONS.reduce((acc, tab, index) => {
  acc[tab.key] = {
    INDEX: index,
    PATH: tab.path,
  }

  return acc
}, {})

export const getVisibleTabs = features =>
  TAB_DEFINITIONS.filter(tab => {
    if (!tab.feature)
      return true

    return features?.[tab.feature] === true
  })

export const getTAB = features =>
  getVisibleTabs(features).reduce((acc, tab, index) => {
    acc[tab.key] = {
      INDEX: index,
      PATH: tab.path,
    }

    return acc
  }, {})

